module.exports = __webpack_public_path__ + "static/media/custom-offer4@2x.d77d9c5e.png";